import { render } from "./rwc_terms_consent_checkbox.vue?vue&type=template&id=bba19d0e"
import script from "./rwc_terms_consent_checkbox.vue?vue&type=script&lang=js"
export * from "./rwc_terms_consent_checkbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__